import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-562">
        {label && <label htmlFor={inputId} className="block text-sm font-semibold text-white mb-2" data-id="element-563">
            {label}
          </label>}
        <input ref={ref} id={inputId} className={`w-full px-4 py-3 bg-dark-surface text-white border-2 border-dark-border rounded-industrial focus:outline-none focus:border-brand-yellow transition-colors ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-564" />
        {error && <p className="mt-1 text-sm text-red-500" role="alert" data-id="element-565">
            {error}
          </p>}
      </div>;
});
Input.displayName = 'Input';